<template>
    <div class="card-order box ">
        <div class="column columns is-vcentered is-multiline">
            <div class="column is-full">
                <b-tag
                    class="column is-full is-size-7"
                    type="is-warning"
                >Lalamove Order ID: #{{ lalamoveID }}</b-tag>
                <b-tag
                    style="margin-top:5px"
                    class="column is-full is-size-7"
                    type="is-info"
                >Villa Order ID: #{{ villaID }}</b-tag>
            </div>
            <div class="column is-one-third">
                <b-tag
                    style="height:100%"
                    class="column is-full is-size-6-mobile is-uppercase"
                    type="is-success is-light"
                >
                    <div>Status: </div>
                    <div class="has-text-weight-bold">{{ status }}</div>
                </b-tag>
            </div>
            <div
                class="column share-link-btn"
                @click.stop="onClickLink"
            >
                <b-button
                    expanded
                    type="is-link is-light"
                    icon-pack="fas"
                    icon-left="map-marked"
                >Tracking Lalamove</b-button>
                <!-- {{shareLink}} -->
            </div>
        </div>
        <div
            class="column"
            style="text-align: center;"
            v-if="cancelFlag"
        >
            <b-button
                class="cancel-btn"
                type="is-danger"
                size="is-small"
                icon-pack="fas"
                icon-left="window-close"
                @click="onClickCancelOrderLalamove()"
            >Cancel Order Lalamove</b-button>
        </div>
    </div>
</template>

<script>
// let branch = require('@/assets/logo-villa-mobile.svg')
import dayjs from "dayjs";
export default {
  props: ["info", "villaID", "lalamoveID", "status", "shareLink", "updatedAt"],
  data() {
    return {
      description: false,
      timeoutInFiveMinuit: null,
      timeCancelOrder: dayjs(),
      tempTimeOut: 5 * 60, //min to sec
      timeStart: dayjs(),
      cancelFlag: false,
    };
  },
  mounted() {
    this.ableToCancleOrder();
  },
  methods: {
    ableToCancleOrder() {
      switch (this.status) {
        case "CREATELALAMOVE": {
          this.cancelFlag = true;
          break;
        }
        case "ASSIGNING_DRIVER": {
          this.cancelFlag = true;
          break;
        }
        case "ON_GOING": {
          console.log("time diff", this.timeCancelOrder.diff(this.updatedAt, "second"));
          if (this.timeCancelOrder.diff(this.updatedAt, "second") >= this.tempTimeOut) {
            this.cancelFlag = false;
          } else {
            this.cancelOrderTimeOut();
            this.cancelFlag = true;
          }
          break;
        }
        default: {
          this.cancelFlag = false;
          break;
        }
      }
      // return false
    },
    cancelOrderTimeOut() {
      console.log(
        "SET TIME OUT in",
        (this.tempTimeOut - this.timeCancelOrder.diff(this.updatedAt, "second")) * 1000
      );
      this.timeoutInFiveMinuit = setTimeout(() => {
        this.cancelFlag = false;
        this.clearCancelOrderTimeOut();
      }, (this.tempTimeOut - this.timeCancelOrder.diff(this.updatedAt, "second")) * 1000);
    },
    clearCancelOrderTimeOut() {
      clearTimeout(this.timeoutInFiveMinuit);
      console.log("CLEAR TIME OUT", typeof this.timeoutInFiveMinuit);
    },
    async onClickCancelOrderLalamove() {
      console.log("cancel order lalamove >>>", this.lalamoveID);
      const res = await this.$store.dispatch("lalamove/cancelOrder", this.lalamoveID);
      if (res.status.statusCode === 200) {
        this.$buefy.notification.open({
          message: `LALAMOVE ${res.data.message}`,
          type: "is-danger",
          duration: 5000,
          queue: false,
        });
      }
    },
    // onclickCard() {
    //   // const position = {
    //   //   origin: this.origin,
    //   //   destination: this.destination,
    //   //   id: this.id,
    //   //   active: this.description,
    //   // };
    //   this.description = !this.description;
    //   // this.$emit("onclick", position);
    // },
    onClickLink() {
      // window.location.href = this.shareLink;
      window.open(this.shareLink, "_blank");
    },
  },
  beforeDestroy() {
    if (this.timeoutInFiveMinuit) {
      this.clearCancelOrderTimeOut();
    }
  },
};
</script>

<style scoped>
.card-order {
  border: 1px solid white;
  cursor: pointer;
  color: white;
  /* border-radius: 10px; */
  /* margin: 0.5rem 0.5rem; */
  border-bottom: 1px solid #e8e8e8;
}
.card-order {
  background-color: white;
  color: #2c2a74;
}
.share-link-btn {
  opacity: 0.7;
}
.share-link-btn:hover {
  opacity: 1;
}
.cancel-btn {
  opacity: 0.5;
}
.cancel-btn:hover {
  opacity: 1;
}
.text-title {
  font-size: 13px;
}
.text-box {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1; /* number of lines to show */
  -webkit-box-orient: vertical;
}
.columns:not(:last-child) {
  margin-bottom: 0;
}
</style>